import MonthYearPicker from "@/components/date-picker/month-year-picker";
import { FutureContractDetail } from "@/pages/grain-requests/future-contract/schema/future-contract.schema";
import { AppColors } from "@/styles/colors";
import { Flex, GridItem, Spinner, Text } from "@chakra-ui/react";
import { Check, PenLine, X } from "lucide-react";
import { Dispatch, SetStateAction } from "react";
import { Control, FieldValues } from "react-hook-form";

interface DeliveryMonthCardProps {
  futureContract?: FutureContractDetail | null;
  isEditingDeliveryMonth?: boolean;
  loadingEditDeliveryMonth?: boolean;
  handleEditDeliveryMonth?: () => void;
  errors?: any;
  control: Control<FieldValues>;
  setIsEditingDeliveryMonth: Dispatch<SetStateAction<boolean>>;
  clearErrors: (name?: string | string[] | undefined) => void;
  setValue: (name: string, value: any) => void;
  cantOperateFutureContract: boolean;
  hasWriteAccess: boolean;
}

export const DeliveryMonthCard = ({
  futureContract,
  isEditingDeliveryMonth,
  loadingEditDeliveryMonth,
  handleEditDeliveryMonth,
  errors,
  control,
  setIsEditingDeliveryMonth,
  clearErrors,
  setValue,
  cantOperateFutureContract,
  hasWriteAccess,
}: DeliveryMonthCardProps) => {
  return (
    <GridItem minW={isEditingDeliveryMonth ? "240px" : "auto"}>
      <Flex
        minH={"82px"}
        gap="10px"
        padding="12px"
        flexDir="column"
        borderRadius="12px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Text
          fontWeight={700}
          fontSize="12px"
          color={AppColors.GRAY_TEXT}
          textTransform={"uppercase"}
        >
          Entrega
        </Text>
        <Flex alignItems="flex-start" gap="6px">
          {isEditingDeliveryMonth ? (
            <MonthYearPicker
              name="future_contract_delivery_month"
              control={control}
              disabled={loadingEditDeliveryMonth}
              placeholder="Seleccionar mes y año"
              required
              clearable
              maxW="175px"
              errors={errors.future_contract_delivery_month}
              maxMonthsAhead={16}
              minMonthsFromNow={0}
            />
          ) : (
            <Flex alignItems="center" gap="8px">
              <Text
                fontSize={{
                  base: "15px",
                  sm: "15px",
                  md: "15px",
                  lg: "18px",
                  xl: "20px",
                }}
                fontWeight={700}
              >
                {futureContract?.entrega ?? "-"}
              </Text>

              {!cantOperateFutureContract && hasWriteAccess && (
                <PenLine
                  data-testid="cash-pen-line"
                  cursor="pointer"
                  onClick={() => {
                    setIsEditingDeliveryMonth(true);
                    setValue(
                      "future_contract_delivery_month",
                      String(futureContract?.entrega),
                    );
                  }}
                />
              )}
            </Flex>
          )}

          {loadingEditDeliveryMonth && isEditingDeliveryMonth && (
            <Spinner
              style={{
                marginTop: 10,
              }}
              data-testid="future-contract-edit-delivery-month-spinner"
            />
          )}
          {isEditingDeliveryMonth && !loadingEditDeliveryMonth && (
            <Check
              style={{
                marginTop: 10,
              }}
              cursor={
                errors?.future_contract_delivery_month
                  ? "not-allowed"
                  : "pointer"
              }
              onClick={handleEditDeliveryMonth}
              data-testid="future-contract-edit-delivery-month-button"
            />
          )}
          {isEditingDeliveryMonth && (
            <X
              style={{
                marginTop: 10,
              }}
              data-testid="future-contract-cancel-edit-delivery-month-button"
              cursor="pointer"
              onClick={() => {
                setIsEditingDeliveryMonth(false);
                clearErrors("future_contract_delivery_month");
              }}
            />
          )}
        </Flex>
      </Flex>
    </GridItem>
  );
};
